(function(con) {
  const empty = {};
  const dummy = function() {};
  const properties = 'memory'.split(',');
  const methods = (
    'assert,clear,count,debug,dir,dirxml,error,exception,group,' +
    'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
    'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn'
  ).split(',');
  properties.forEach(prop => {
    con[prop] = con[prop] || empty;
  });
  methods.forEach(method => {
    con[method] = con[method] || dummy;
  });
})((window.console = window.console || {}));
